import removeDuplicatesFromArray from '@/utils/removeDuplicatesFromArray'

function getRelatedPostsBasedOnCategory(categories) {
  const relations = categories?.map((category) => category.posts.nodes).flat(Infinity) || []
  return removeDuplicatesFromArray(relations)
}

function resolveSidebarBlocks(data, posts) {
  if (!data.sidebarAcf?.sidebarBlocks) return []

  return data.sidebarAcf.sidebarBlocks.map((block) => {
    if (block.contentType === 'tags') {
      return { ...block, tags: data.categories?.nodes }
    }

    if (block.contentType === 'related_posts' || block.contentType === 'latest_related_posts') {
      const relatedPosts = getRelatedPostsBasedOnCategory(data.categories?.nodes) || []
      const selectedPosts = block.relatedPosts || block.latestRelatedPosts || []
      const posts = [...selectedPosts, ...relatedPosts].slice(0, 3)
      const uniquePosts = removeDuplicatesFromArray(posts)
      return { ...block, posts: uniquePosts }
    }

    if (block.contentType === 'latest_posts') {
      return { ...block, posts: posts }
    }

    if (block.contentType === 'share') {
      return { ...block, seo: data.seo }
    }

    return block
  })
}

export default resolveSidebarBlocks
